export const PermissionOrder = {
    PUT: "mgr-orders-**-status-customers-**-PUT",
    GET: "mgr-orders-custom-search-GET",
    GET_UUID: "mgr-orders-**-customers-**-GET"
};